import { Box, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import '../styles.scss'
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseIcon from '@mui/icons-material/Close';
import { UpdateDiagnosticForActivity, updateUpdateDiagnosticForActivity } from 'src/shared/util/updateDataServer';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import Swal from "sweetalert2";
import { useParams } from 'react-router-dom';
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import { DynSort } from '../sort_dyn';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { generateDiagnostic } from 'src/tecnica/utils/generateDiagnostic';
import { getLocations } from 'src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { ModalVariables } from '../modalVariables';
import { OptimizationActivities } from './modalDiagnosticOptimization';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PublishIcon from '@mui/icons-material/Publish';

const status_candidato_listy = [
    { id: "Reevaluación", name: "Reevaluación" },
    { id: "Oportunidad de Incremento", name: "Oportunidad de Incremento" },
    { id: "Mantener Condiciones", name: "Mantener Condiciones" }
]

const condicion_fondo_list = [
    { id: "Golpe de Fluido", name: "Golpe de Fluido" },
    { id: "Inteferencia por Gas", name: "Inteferencia por Gas" },
    { id: "Pendiente por Determinar", name: "Pendiente por Determinar" },
    { id: "Buenas Condiciones", name: "Buenas Condiciones" },
    { id: "Golpe de Bomba", name: "Golpe de Bomba" },
    { id: "Baja Accion de Bombeo", name: "Baja Accion de Bombeo" },
    { id: "Fuga en Valvula Viajera", name: "Fuga en Valvula Viajera" },
    { id: "Fuga en Valvula Fija", name: "Fuga en Valvula Fija" },
    { id: "Cierre Tardio de Valvula Fija", name: "Cierre Tardio de Valvula Fija" },
    { id: "Cierra Tardio de Valvula Viajera", name: "Cierra Tardio de Valvula Viajera" },
    { id: "Flumping", name: "Flumping" }
];

const taskStates = [
    { id: "pending", name: "Por Analizar" },
    { id: "analyzing", name: "Evaluar Luego" },
    { id: "finished", name: "Analiazada" }
];


export const ModalDiagnostic = ({ open, onClose, sortDyns, activeDyn, listSortDyns }: { open: any, onClose: any, sortDyns: any, activeDyn: any, listSortDyns: DynSort[] }) => {

    const [loading, setloading] = useState(false)

    const { id } = useParams();

    const dispatch = useDispatch();

    const { projectId, locationId, optimizationRequirements } = useSelector((state) => state.location);

    const { activeUser } = useSelector((state) => state.main);

    const [showVariables, setShowVariables] = useState("diagnostic")

    const [activeDiagnostic, setActiveDiagnostic] = useState<UpdateDiagnosticForActivity>()


    useEffect(() => {

        console.log({ sortDyns, activeDyn, listSortDyns })

        const originFieldActivityIds = listSortDyns?.map((dyn) => dyn.fieldActivityId)

        const mpt = activeDyn?.mpt

        const ept = activeDyn?.ept

        const dplunger = sortDyns?.dpluger

        const fillage = ept / mpt * 100

        const newActiveDiagnostic: UpdateDiagnosticForActivity = {
            originFieldActivityIds,
            projectId: projectId,
            locationId: locationId,
            diagnostic: sortDyns?.diagnostic || '',
            recommendation: sortDyns?.recommendations || '',
            candidateSate: sortDyns?.candidateSate || '',
            bottomHoleCondition: sortDyns?.bottomHoleConditions || '',
            subBottomHoleCondition: sortDyns?.subBottomHoleConditions || '',
            bottomHoleFillage: fillage,
            requiredUserId: activeUser?.id || '',
            executedAt: new Date(),
            ept,
            theoricalProduction: sortDyns?.bbpd || 0,
            pumpEfficiency: sortDyns?.pumpEfficiency,
            adjustProduction: sortDyns?.adjustProduction || 0,
            mpt,
            dplunger,
            newFieldActivityState: 'finished',
            optimizationActivitiesSelected: sortDyns?.optimizationActivitiesSelected || [],
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }, [sortDyns, activeDyn, listSortDyns])

    const validateDiagnostic = () => {
        const fieldsToValidate = [
            { field: 'diagnostic', message: "El campo diagnostico es requerido" },
            { field: 'recommendation', message: "El campo recomendacion es requerido" },
            { field: 'candidateSate', message: "El campo estado candidato es requerido" },
            { field: 'bottomHoleCondition', message: "El campo condicion de fondo es requerido" }]

        const messageErros: string[] = []

        if (!activeDiagnostic) return messageErros

        const diagnosticTovalidate: any = { ...activeDiagnostic }

        fieldsToValidate.forEach((f) => {
            if (!diagnosticTovalidate[f.field] || diagnosticTovalidate[f.field].trim() === "") {
                messageErros.push(f.message)
            }
        }
        )

        if (!(diagnosticTovalidate?.optimizationActivitiesSelected?.length > 0)) {
            messageErros.push("Debe seleccionar al menos una opcion de optimizacion")
        }

        return messageErros
    }

    const onSaveDiagnostic = () => {
        if (activeDiagnostic) {

            const errors = validateDiagnostic()

            if (errors.length > 0) {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                    html: `<p>No se puede proceder debido a los siguientes errores:</p><ul>${errors.map(error => `<li>${error}</li>`).join('')}</ul>`

                });
                return
            }

            setloading(true)
            updateUpdateDiagnosticForActivity(activeDiagnostic).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
                dispatch(getLocations(true));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }
    }


    const handleClose = () => {
        if (loading) return
        onClose()
    }

    const generateSimpleDiagnostic = () => {
        const diagnostic = generateDiagnostic(activeDyn, activeDiagnostic, sortDyns)
        handleOnChangeValue(diagnostic, "diagnostic")
    }

    const handleOnChangeValue = (value: any, label: any) => {
        const newActiveDiagnostic: any = { ...activeDiagnostic }
        newActiveDiagnostic[label] = value

        if (label === "bottomHoleCondition") {

            let subBottomHoleCondition = ""

            const condicionesDeficiente = ['Fuga en Valvula Viajera', 'Fuga en Valvula Fija', 'Cierre Tardio de Valvula Fija', 'Cierra Tardio de Valvula Viajera', 'Flumping', "Baja Accion de Bombeo"]

            switch (value) {
                case "Golpe de Fluido":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Golpe de Fluido Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Golpe de Fluido Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Golpe de Fluido Buen Llenado (50% al 90%)"
                    }

                    break;
                case "Inteferencia por Gas":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Interferencia por Gas Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Interferencia por Gas Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Interferencia por Gas Buen Llenado (50% al 90%)"
                    }

                    break;

                default:
                    if (condicionesDeficiente.includes(value)) {
                        subBottomHoleCondition = "Deficiente";
                    } else {
                        subBottomHoleCondition = value;
                    }
                    break;

            }

            newActiveDiagnostic["subBottomHoleCondition"] = subBottomHoleCondition
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }

    const addRemoveOptimizationActivity = (activity: any, add: boolean) => {
        if (!activeDiagnostic) return

        let id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id

        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || []
        const filteredActivities = optimizationActivities.filter((opt) => opt.id !== id)
        const newOptimizationActivitiesSelected = [...filteredActivities]
        if (add) {
            newOptimizationActivitiesSelected.push({
                id: id,
                name: activity.activity,
                simulated: activity?.simulated || false,
                optimizationActivityId: activity.optimizationActivityId,
                main: activity?.main || false
            })
        }

        setActiveDiagnostic({
            ...activeDiagnostic,
            optimizationActivitiesSelected: newOptimizationActivitiesSelected
        })
    }

    const handleConvertToMain = (activity: any) => {
        if (!activeDiagnostic) return

        let id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id

        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || []
        
        const newOptimizationActivitiesSelected = optimizationActivities.map((opt) => {
            if (opt.id === id) {
                return { ...opt, main: true }
            } else {
                return { ...opt, main: false }
            }
        })

        // Sort to have the main activity first
        newOptimizationActivitiesSelected.sort((a, b) => (b.main ? 1 : 0) - (a.main ? 1 : 0));

        setActiveDiagnostic({
            ...activeDiagnostic,
            optimizationActivitiesSelected: newOptimizationActivitiesSelected
        })
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <>
                <Box className="modal_update_card_location">
                    {/* headers */}
                    <Box className="modal_header">
                        <IconButton
                            aria-label="delete"
                            size='small'
                            onClick={handleClose}
                        >
                            <CloseIcon color="error" />
                        </IconButton>
                        <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                            Agregar Diagnostico
                        </Typography>
                        {showVariables === "diagnostic" && (
                            <IconButton
                                aria-label="delete"
                                size='small'
                                onClick={() => onSaveDiagnostic()}
                            >
                                <SaveOutlinedIcon color="primary" />
                            </IconButton>
                        )}

                    </Box>
                    {loading && (
                        <>
                            <Box className="modal_analyst_loading_background" />
                            <Box className="modal__analyst_task_loading">
                                <LinearProgress />
                                Saving....
                            </Box>
                        </>
                    )}
                    < Box className="modal_analyst_body" >

                        <Grid size={12}>
                            <Grid style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb: 1 }}>
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={showVariables}
                                        exclusive
                                        size='small'
                                        onChange={(_event, value) => setShowVariables(value)}
                                        aria-label="Platform"
                                    >
                                        <ToggleButton value="variables">Variables</ToggleButton>
                                        <ToggleButton value="diagnostic">Diagnostico</ToggleButton>
                                        <ToggleButton value="optimizationOptions">Opciones de Optimizacion</ToggleButton>
                                    </ToggleButtonGroup>
                                    {showVariables === "diagnostic" && (
                                        <IconButton size="small" onClick={() => generateSimpleDiagnostic()}>
                                            <AutoAwesomeIcon color="primary" />
                                        </IconButton>
                                    )}
                                </Box>
                            </Grid>
                            {showVariables === "diagnostic" && (
                                <TextField
                                    id="variable"
                                    size="small"
                                    label={"Diagnostico"}
                                    value={activeDiagnostic?.diagnostic || ""}
                                    onChange={(e) => handleOnChangeValue(e.target.value, "diagnostic")}
                                    fullWidth
                                    error={!activeDiagnostic?.diagnostic || activeDiagnostic?.diagnostic.trim() === ""}
                                    multiline
                                    rows={3}
                                />
                            )}

                        </Grid>
                        {showVariables === "diagnostic" && (
                            <>
                                <Grid size={12}>
                                    <TextField
                                        id="variable"
                                        size="small"
                                        label={"Recomendacion"}
                                        onChange={(e) => handleOnChangeValue(e.target.value, "recommendation")}
                                        value={activeDiagnostic?.recommendation || ""}
                                        error={!activeDiagnostic?.recommendation || activeDiagnostic?.recommendation.trim() === ""}
                                        fullWidth
                                        multiline
                                        rows={3}
                                    />
                                </Grid>
                                <Grid className="list_section">
                                    <FormControl>
                                        <InputLabel>Estatus Candidato</InputLabel>
                                        <Select
                                            value={activeDiagnostic?.candidateSate || ""}
                                            label="Estatus Candidato"
                                            onChange={(e) => handleOnChangeValue(e.target.value, "candidateSate")}
                                            error={!activeDiagnostic?.candidateSate || activeDiagnostic?.candidateSate.trim() === ""}
                                        >
                                            {status_candidato_listy.map((status) => (
                                                <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel>Condición de Fondo</InputLabel>
                                        <Select
                                            value={activeDiagnostic?.bottomHoleCondition || ""}
                                            label="Condición de Fondo"
                                            onChange={(e) => handleOnChangeValue(e.target.value, "bottomHoleCondition")}
                                            error={!activeDiagnostic?.bottomHoleCondition || activeDiagnostic?.bottomHoleCondition.trim() === ""}
                                        >
                                            {condicion_fondo_list.map((cond) => (
                                                <MenuItem key={cond.id} value={cond.id}>{cond.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel>Nuevo Estado tarea</InputLabel>
                                        <Select
                                            value={activeDiagnostic?.newFieldActivityState || ""}
                                            label="Nuevo Estado tarea"
                                            onChange={(e) => handleOnChangeValue(e.target.value, "newFieldActivityState")}
                                            error={!activeDiagnostic?.newFieldActivityState || activeDiagnostic?.newFieldActivityState.trim() === ""}
                                        >
                                            {taskStates.map((task) => (
                                                <MenuItem key={task.id} value={task.id}>{task.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Grid className="sub_states_sections">
                                        <Grid className="label">Llenado : </Grid>
                                        <Grid>  {activeDiagnostic?.bottomHoleFillage ? Math.round(activeDiagnostic?.bottomHoleFillage) : 0} % </Grid>
                                        <Grid className="label">Sub Condicion : </Grid>
                                        <Grid> {activeDiagnostic?.subBottomHoleCondition || ""}  </Grid>
                                    </Grid>
                                    <Typography className='text_label_section' sx={{ fontWeight: 'bold' }}>Opciones de optimizacion : </Typography>
                                    <Grid className='optimization_list_elements'>
                                        {activeDiagnostic?.optimizationActivitiesSelected?.map((opt, i) => (
                                            <Grid className='element' key={i}>
                                                <Typography className='text_section'>
                                                    {opt?.name}
                                                </Typography>
                                                <Tooltip title={"Convertir en principal"}>
                                                    <IconButton onClick={() => handleConvertToMain(opt)}>
                                                        {opt?.main
                                                            ? <LooksOneIcon color="primary" />
                                                            : <PublishIcon color="disabled" />}
                                                    </IconButton>
                                                </Tooltip>
                                                <IconButton
                                                    size="small"
                                                    color={"error"}
                                                    onClick={() => addRemoveOptimizationActivity(opt, false)}
                                                >
                                                    <DeleteForeverIcon fontSize="medium" />
                                                </IconButton>
                                            </Grid>
                                        ))}
                                        {activeDiagnostic?.optimizationActivitiesSelected?.length === 0 && (
                                            <Grid className='disable_element'>
                                                Debe Seleccionar almenos una opcion de optimizacion de las disponibles
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </Box>
                    {showVariables === "variables" && (
                        <ModalVariables
                            sortDyns={sortDyns}
                            open={undefined}
                            onClose={undefined}
                            showAsModal={false}
                        />
                    )}
                    {showVariables === "optimizationOptions" && (
                        <OptimizationActivities
                            originFieldActivityIdFromDiagnostic={activeDiagnostic?.originFieldActivityIds[0] || ""}
                            addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                            handleConvertToMain={handleConvertToMain}
                            activeDiagnostic={activeDiagnostic}
                        />
                    )}
                </Box>
            </>
        </Modal>
    )
}